import { createI18n } from "@agportal/locale";
import common from "@dmvs/messages";
import { merge } from "lodash-es";

import cs from "./cs";

export default createI18n({
    messages: merge({}, common, { cs }),
});
